<template>
  <v-stepper v-model="currentStep">
    <v-card-title>
      <div class="headline">
        Добавление счетчика
      </div>
    </v-card-title>
    <v-stepper-header>
      <template v-for="(step, key) in counterSteps">
        <v-stepper-step
          :key="key"
          :complete="currentStep > key + 1"
          :editable="currentStep > key + 1"
          :step="key + 1"
        >{{ step }}</v-stepper-step>
        <v-divider
          v-if="key < 4"
          :key="`${key}-divider`"
        />
      </template>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content step="1">
        <v-autocomplete
          v-model="resourceTypeId"
          :items="resourcesTypes"
          label="Энергоресурс"
          item-text="name"
          item-value="resource_type_id"
          :menu-props="{maxHeight:'auto'}"
          @input="getModelsGroupsApi"
        />
        <v-autocomplete
          v-model="modelGroupId"
          :items="modelsGroups"
          :disabled="!modelsGroups.length"
          label="Группа счётчиков"
          item-text="name"
          item-value="counter_model_api_id"
          :menu-props="{maxHeight:'auto'}"
          @input="getModelsApi"
        />
        <v-autocomplete
          v-model="counter.model_id"
          :items="models"
          :disabled="!models.length"
          label="Модель"
          item-text="name"
          item-value="model_id"
          :menu-props="{maxHeight:'auto'}"
          @input="nextCounterStep('getConnectParameters')"
        />
        <div class="d-flex">
          <v-spacer />
          <v-btn
            v-if="counter.model_id"
            color="primary"
            text
            @click="currentStep++"
          >Вперёд</v-btn>
          <v-btn
            color="primary"
            text
            @click="$emit('cancel')"
          >Отмена</v-btn>
        </div>
      </v-stepper-content>
      <v-stepper-content step="2">
        <v-select
          v-model="sourceParam.value"
          :items="sourceParams"
          label="Источник данных"
        />
        <v-text-field
          v-for="param in visibleParams"
          :key="param.param"
          v-model="param.value"
          :label="param.name + ' (' + param.remark + ')'"
        />
        <div class="d-flex">
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="currentStep++"
          >Вперёд</v-btn>
<!--          <v-btn-->
<!--            color="primary"-->
<!--            text-->
<!--            @click="checkConnectParameters"-->
<!--          >-->
<!--            Проверить-->
<!--            <br>{{ connectStatus }}-->
<!--          </v-btn>-->
          <v-btn
            color="primary"
            text
            @click="$emit('cancel')"
          >Отмена</v-btn>
        </div>
      </v-stepper-content>
      <v-stepper-content step="3">
        <v-radio-group
          v-model="isExistingCounterSelected"
          :column="false"
          hide-details
        >
          <v-radio
            label="Новый счетчик"
            color="primary"
            :value="false"
          ></v-radio>
          <v-radio
            label="Существующий счетчик"
            color="primary"
            :value="true"
          ></v-radio>
        </v-radio-group>
        <v-form ref="counterParamsForm">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                v-if="isExistingCounterSelected"
              >
                <v-menu
                  v-model="existingCounterMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="existingCounter.serial_num"
                      label="Существующий счётчик"
                      :rules="inputRules"
                      required
                      readonly
                    />
                  </template>
                  <point-counter-install-existed
                    :model-id="counter.model_id"
                    @selected="selectCounter"
                  />
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="counter.serial_num"
                  label="Серийный номер"
                  :rules="inputRules"
                  required
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="counter.coeff"
                  label="Коэффициент трансформации тока"
                  :rules="inputRules"
                  required
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="counter.coeff_voltage"
                    label="Коэффициент трансформации напряжения"
                    :rules="inputRules"
                    required
                />
              </v-col>
              <v-col cols="12">
                <v-menu
                  v-model="operDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="operDate"
                      label="Дата операции"
                      readonly
                      @blur="operDateVal = parseDate(operDate)"
                    />
                  </template>
                  <v-date-picker
                    v-model="operDateVal"
                    no-title
                    scrollable
                    locale="ru-RU"
                    @input="operDateMenu = false"
                  />
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <div class="d-flex">
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="addCounter"
          >Установить</v-btn>
          <v-btn
            color="primary"
            text
            @click="$emit('cancel')"
          >Отмена</v-btn>
        </div>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import PointCounterInstallExisted from './PointCounterInstallExisted.vue'
export default {
  name: 'PointCounterInstall',
  components: {
    PointCounterInstallExisted
  },
  props: {
    pointId: {}
  },
  data () {
    return {
      inputRules: [
        v => !!v || 'Заполните это поле!'
      ],
      operDateMenu: false,
      operDateVal: null,
      operDate: null,
      counter_oper: {
        operation_date: null
      },
      isExistingCounterSelected: false,
      existingCounter: {},
      counter: {},
      existingCounterMenu: false,
      counterSteps: ['Модель', 'Параметры подключения', 'Параметры счётчика'],
      currentStep: 1,
      resourcesTypes: [],
      resourceTypeId: null,
      modelsGroups: [],
      modelGroupId: null,
      models: [],
      sourceParams: ['TCP', 'lorawandb'],
      sourceParam: {},
      dataParams: [],
      connectStatus: null
    }
  },
  computed: {
    visibleParams () {
      return this.dataParams.filter(item =>
        this.sourceParam.value === 'TCP'
          ? item.param !== 'source'
          : item.param === 'net_address'
      )
    }
  },
  watch: {
    resourceTypeId () {
      this.modelGroupId = null
      this.models = []
    },
    modelGroupId () {
      this.counter = {}
      this.existingCounter = {}
    },
    'counter.model_id' (val) {
      this.counter = { model_id: val }
      this.existingCounter = { model_id: val }
    },
    isExistingCounterSelected (val) {
      this.counter = { model_id: this.counter.model_id }
      if (val) {
        this.counter = Object.assign({}, this.counter, this.existingCounter)
      }
    },
    operDateVal () {
      this.operDate = this.formatDate(this.operDateVal)
      this.counter_oper.operation_date = this.operDateVal
    }
  },
  mounted () {
    var currentDate = new Date()
    this.operDateVal = this.parseDate(currentDate.getDate() + '/' + (currentDate.getMonth() + 1) + '/' + currentDate.getFullYear())
    this.counter_oper.point_id = this.pointId
    this.getResourcesTypesApi()
  },
  methods: {
    getResourcesTypesApi () {
      this.axios.get(`/api/resources_types/`)
        .then((response) => {
          this.resourcesTypes = response.data.results
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getModelsGroupsApi () {
      this.axios.get(`/api/counters_api/?resource_type=${this.resourceTypeId}`)
        .then((response) => {
          this.modelsGroups = response.data.results
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getModelsApi () {
      this.axios.get(`/api/counters_models/?counter_model_api=${this.modelGroupId}`)
        .then((response) => {
          this.models = response.data.results
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getConnectParameters () {
      this.axios.get(`/api/counters/${this.modelGroupId}/model_conn_params/`)
        .then((response) => {
          this.dataParams = response.data
          this.dataParams.map(param => { param.value = '' })
          this.sourceParam = { param: 'source', value: 'TCP' }
          this.dataParams.push(this.sourceParam)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    checkConnectParameters () {
      this.connectStatus = this.connectStatus === 'Удачно' ? 'Ошибка' : 'Удачно'
    },
    selectCounter (counter) {
      this.existingCounter = Object.assign({}, this.existingCounter, {
        counter_id: counter.counter_id,
        coeff: counter.coeff,
        coeff_voltage: counter.coeff_voltage,
        serial_num: counter.serial_num
      })
      this.counter = Object.assign({}, this.counter, this.existingCounter)
      this.existingCounterMenu = false
    },
    nextCounterStep (nextMethod) {
      this.currentStep++

      if (nextMethod) {
        this[nextMethod]()
      }
    },
    addCounter () {
      if (this.$refs.counterParamsForm.validate()) {
        const connectParameters = { conn_params: this.dataParams }
        const url = this.counter.counter_id
          ? `/api/counters/${this.counter.counter_id}/update_and_install/`
          : `/api/counters/create_and_install/`
        this.axios.post(url, Object.assign({}, this.counter, this.counter_oper, connectParameters))
          .then((response) => {
            response.data.install_date = `${this.counter_oper.operation_date} 00:00:00`
            this.$emit('installed', response.data)
          })
          .catch((err) => {
            this.$emit('installError', err.response.data)
          })
      }
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/spa/points/counters/PointCounterInstall.vue